// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__c9-EE","onScreen":"Heading_onScreen__CXgI2"};